import React, {useEffect, useState} from 'react';
import {Button, Collapse, Dropdown, DropdownDivider} from "react-bootstrap";
import {useAuth} from "../../../context/AuthContext";

const MainHeader = ({partner}) => {
    const auth = useAuth();
    const [favourites, setFavourites] = useState(JSON.parse(localStorage.getItem("favourites") || "[]"));
    const [open, setOpen] = useState(false);

    useEffect(() => {
        window.addEventListener('storage', () => {
            setFavourites(JSON.parse(localStorage.getItem("favourites") || "[]"))
        });
    }, [partner]);
    return (
        <div className="main-header">
            <div className="container-fluid container-xxl">
                <div className="d-flex py-3 align-items-center justify-content-between">

                    <div className="d-none d-md-block">
                        <a className="navbar-brand" href={`${process.env.PUBLIC_URL}/`}>
                            <img src={`${process.env.REACT_APP_LOGOS_PATH}/${partner.header_logo}`}
                                 alt={partner.name}
                                 title={partner.name}
                                 className="img-logo"/>
                        </a>
                    </div>

                    <form method="get" className="search-form desktop-search-form "
                          action={`${process.env.PUBLIC_URL}/reisefinder`}>
                        <div className="input-group">
                            <input
                                aria-label="Suchbegriff eingeben"
                                type="text" name="s" className="form-control"
                                placeholder="Suchbegriff eingeben..." id="search-input"/>
                            <button className="btn" type="submit" aria-label="Suchen">
                                <i className="bi bi-search" title="Suchen"></i> Suchen
                            </button>
                        </div>
                    </form>

                    <div className="header-actions d-flex align-items-center justify-content-end">
                        <Button variant="link" className="header-action-btn mobile-search-toggle d-xl-none"
                                onClick={() => setOpen(!open)}
                                aria-controls="example-collapse-text"
                                aria-expanded={open}
                                aria-label="Reise Suchen"
                        ><i className="bi bi-search" title="Suchen"></i>
                        </Button>

                        {auth.user ? (
                            <Dropdown className="account-dropdown">
                                <Dropdown.Toggle variant="success" id="dropdown-basic"
                                                 className="header-action-btn">
                                    <i className="bi bi-person" title="User Account"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-body">
                                    <Dropdown.Item className="dropdown-item d-flex align-items-center"
                                                   href="/dashboard">
                                        <i className="bi bi-person-circle me-2"></i>
                                        <span>Profile</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item className="dropdown-item d-flex align-items-center"
                                                   href="/dashboard">
                                        <i className="bi bi-card-checklist me-2"></i>
                                        <span>Dashboard</span>
                                    </Dropdown.Item>
                                    <DropdownDivider></DropdownDivider>
                                    <Dropdown.Item className="dropdown-item d-flex align-items-center"
                                                   href="/logout"> <i className="fa fa-sign-out me-2"></i>
                                        <span>Abmelden</span></Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>) : (
                            <a className="header-action-btn" href="/login" title="Einloggen zum User Account">
                                <i className="bi bi-person"></i>
                            </a>
                        )}

                        <button type="button" data-bs-toggle="modal" data-bs-target="#favModal"
                                className="header-action-btn d-md-block" title="Favouriten  anzeigen">
                            <i className={favourites.length > 0 ? "bi bi-heart-fill text-primary" : "bi bi-heart"}></i>
                            <span className="badge">{favourites.length}</span>
                        </button>

                        <a href="/newsletter-anmeldung" title="Newsletter"
                           className="header-action-btn d-xl-none d-md-block">
                            <i className="bi bi-envelope"></i>
                        </a>

                        <a href="/katalog-gratis-bestellen" title="Prospekt bestellen"
                           className="header-action-btn d-xl-none d-md-block">
                            <i className="bi bi-newspaper"></i>
                        </a>
                    </div>
                </div>
            </div>
            <Collapse in={open}>
                <div className="" id="mobileSearch">
                    <div className="container">
                        <form className="search-form" method="get" action={`${process.env.PUBLIC_URL}/reisefinder`}>
                            <div className="input-group">
                                <input type="text" className="form-control" name="s"
                                       placeholder="Suchbegriff eingeben..." aria-label="Suchbegriff eingeben"/>
                                <button className="btn" type="submit">
                                    <i className="bi bi-search"></i> suchen
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Collapse>
        </div>
    )
}

export default MainHeader;